import { FC, useState } from "react";
import { Section } from "../types";
import { RenderSection } from "./renderSection";
import { Button, ButtonType } from "../components/modal/button";
import { SlideOverForm } from "../components/modal/SlideoverForm";
import { useForm } from "../app/useForm";
import { BORDER_STYLES } from "../../ui/layout/detailedPages/styles";
import { DEFAULT_BUTTON_STYLES } from "../../ui/layout/molecules/styles";

type ItemRenderT = {
  showMainTitle?: boolean;
};

export const ItemRender: FC<ItemRenderT> = ({ showMainTitle = true }) => {
  const [openModal, setOpenModal] = useState(false);
  const { handleFormAccept, model } = useForm();
  const item = model ? model.item : null;

  const label = item?.label ?? null;

  return (
    <>
      {showMainTitle && label && (
        <h1 className="text-primary justify-start text-3xl font-semibold">
          {label}
        </h1>
      )}

      {item?.sections?.map((section: Section, index: number) =>
        RenderSection(section, index, !!label),
      )}

      {item && (item.action || item.modal) && (
        <>
          <Button
            title={item.action?.label ?? "Save Changes"}
            buttonType="primary"
            type="button"
            onClick={() => {
              if (item.modal) {
                setOpenModal(true);
              } else {
                handleFormAccept(item.action);
              }
            }}
          />

          <SlideOverForm
            open={openModal}
            title={item.modal?.title}
            subtitle=""
            onClose={() => setOpenModal(false)}
            acceptButton={
              item.modal?.buttons?.length === 1
                ? item.modal.buttons[0]
                : undefined
            }
          >
            <div className="px-4 dark:text-white">{item.modal?.message}</div>
            {item.modal?.buttons?.length !== 1 && (
              <div className={`border-t py-5 empty:hidden ${BORDER_STYLES}`}>
                <div className="flex gap-4 empty:hidden">
                  {item.modal?.buttons?.map((button, index) => {
                    let buttonType: ButtonType =
                      button?.style?.background_color === "red"
                        ? "danger"
                        : "primary";

                    return (
                      <Button
                        key={index}
                        title={button.label}
                        buttonType={buttonType}
                        onClick={async () => {
                          const result = await handleFormAccept(button.action);
                          if (result) setOpenModal(false);
                        }}
                        type="button"
                        className={`${DEFAULT_BUTTON_STYLES} grow`}
                      />
                    );
                  })}
                </div>
              </div>
            )}
          </SlideOverForm>
        </>
      )}
    </>
  );
};
